export default {
  title: 'Google-anmeldelsesprogram',
  sections: {
    google_review_settings: 'Indstillinger for Google-anmeldelsesprogram',
  },
  form: {
    reward: {
      label: 'Belønning (point)',
      point_value: '100 point = {{moneyValue}}',
    },
    has_end_date: {
      label: 'Varighed',
      options: {
        false: 'Uendelig',
        true: 'Med bestemt slutdato',
      },
    },
    end_date: {
      label: 'Slutdato',
    },
  },
  tags: {
    inactive: 'Ikke aktiv',
    active: 'Aktiv',
    expired: 'Udløbet',
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
    changes_got_saved: 'Ændringerne er gemt',
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
  },
};
